import { useTranslation } from 'react-i18next'

import {
  RECURRING_PERIOD_KEY_MAP,
  TRIAL_PERIOD_KEY_MAP,
} from '../components/Disclaimer/constants'
import {
  getRecurringInterval,
  getTrialInterval,
} from '../components/Disclaimer/helpers'
import { usePurchaseStore } from './usePurchaseStore'

export const useDisclaimerPeriods = () => {
  const { t } = useTranslation()
  const { trialPeriodDays, periodName, periodQuantity } = usePurchaseStore()

  const trialInterval = getTrialInterval(trialPeriodDays, periodName)
  const recurringInterval = getRecurringInterval(periodName, periodQuantity)

  return {
    trialInterval,
    trialPeriod: t(TRIAL_PERIOD_KEY_MAP[trialInterval.interval], {
      postProcess: 'interval',
      count: trialInterval.count,
    }),
    recurringPeriod: t(RECURRING_PERIOD_KEY_MAP[recurringInterval.interval], {
      postProcess: 'interval',
      count: recurringInterval.count,
    }),
  }
}
